export const logInfo = (str: string) => console.info(str);
export const logError = (...args: any) => console.error(args);
